@if(isPDF() && isIOS()){
<div class="d-flex justify-content-center align-items-center vh-100 flex-column " >
  <p>
    {{'Para uma melhor visualização no seu dispositivo, clique no botão abaixo para abrir o PDF.' | translate}}
  </p>
  <a cnet-filled-button class="fit-content" color="primary" size="small" [href]="this._path" download="doc.pdf" target="_blank">
    {{'Abrir PDF' | translate}}
  </a>
</div>
}@else{
<div [style.height]="'calc( 100vh - '+ heightFooter + '' + heightHeader +'px ) '">
  <iframe title="" #iframe id="ngIframe" class="iframe-legado" appIframeTrackerDirective></iframe>
</div>
}
